export const APP_MANAGED_ROUTES = {
  LANDING_PAGE: '/',
  HOME: '/home',
  SIGN_IN: '/sign-in',
  SIGN_OUT: '/sign-out',
  SUPPORT: '/support',
  METRICS: '/metrics',
  CAREGIVER_HOME: '/caregiver-home',
  SETUP_MARKET_EXPERIENCE: '/setup-market-experience',
};
